module.exports = __webpack_public_path__ + "static/roi-card-c4f7cae1bda4be2fe42d3d0a48bfca40.svg";